<!--
 * @Date: 2020-09-01 16:14:53
 * @LastEditTime: 2020-09-02 13:56:00
 * @LastEditors: Junfeng.wang
-->
<template>
  <div
    class="sy-accessory-file-detail"
    :class="{'sy-accessory-file-detail-mini': miniMode}"
  >
    <template v-if="fileList && fileList.length">
      <p 
        v-for="file in fileList"
        :key="file.uid || file"
        class="file-item font-color-hover-primary"
        @click="handleDownLoad(file)"
        :title="file.originalName || file.name"
      >
        <!-- <i class="el-icon-document"></i> -->
        <span
          class="accessory-file-detail_item-status"
          :style="{
            'backgroundPosition': file._fileType && GetFileIcon(file._fileType)
          }"
        ></span>
        <i class="el-icon-download"></i>
        {{file.originalName || file.name}}
      </p>
      <div class="sy-accessory-file-detail-load-mare" v-if="allFileList.length > 3 && fileList.length <= 3">
        <span class="font-color-link" @click="handleShowMore">
          {{pageText.displayAll}}
          <i class="el-icon-arrow-down"></i>
        </span>
      </div>
    </template>
    <template v-else>-</template>
    <FilePreview
      :prop="{
        prewKey: previewExtraParams.prewKey,
        name: previewExtraParams.name || 'name',
        url: previewExtraParams.url || 'filePath'
      }"
      ref="filePreview"
      :previewDownLoad="false"
      :previewExtraParams="previewExtraParams"
      v-bind="$attrs.filePreview"
      @downLoad="downLoadRequest"
    ></FilePreview>
  </div>
</template>

<script>
  import FilePreview from '../../business/preview/index.vue'
  import Api from './api'
  import { accessorySystemType } from '../../../common/constants'
  import download from '../../../utils/download'
  import Store from '../../../common/catch-state/store'
  import Model from './model'
  import {GetFileIcon} from '../sy-upload/common/constans'

  Store.install(Model)

  export default {
    name: 'accessory-file-detail',
    props: {
      allFileList: {
        type: Array,
        default: () => []
      },
      pageText: {
        type: Object,
        default: () => ({})
      },
      miniMode: {type: Boolean, default: false},
      // 附件预览参数
      previewExtraParams: {
        type: Object,
        default: () => {
          return {
            fileReviewBusinessCode: '',
            bizCode: '',
            prewKey: '',
            name: '',
            url: ''
          }
        }
      }
    },
    components: {FilePreview},
    data () {
      return {
        token: '',
        fileList: [],
        // 当前附件列表 是否展开状态，点击一次展开之后，无收起功能，需求如此
        showMoreFlag: false
      }
    },
    watch: {
      allFileList: {
        immediate: true,
        handler (val) {
          if (val) {
            // watch 全部附件数据change，生成用来展示文件名称前的类型icon图片
            val.forEach(v => {
              const name = v.originalName || v.name
              if (name) {
                let arr = name.split('.')
                v._fileType = arr[arr.length - 1]
              }
            })
            // 执行展示逻辑，如果第一次只有1个附件，第二次有4个附件，就需要在不是展开状态的情况下截取前三个展示
            this.showMore()
          }
        }
      }
    },
    methods: {
      GetFileIcon,
      handleDownLoad (file) {
        if (this.$attrs['on-preview']) {
          this.$attrs['on-preview'](file)
          return
        }
        if (this.previewExtraParams.fileReviewBusinessCode) {
          this.$refs['filePreview'].preview(file, this.allFileList.map(v => {
            if (!v[this.previewExtraParams.prewKey]) {
              v[this.previewExtraParams.prewKey] = v.key
            }
            if (!this.previewExtraParams.name && !v.name) {
              v.name = v.originalName
            } else if (this.previewExtraParams.name && !v[this.previewExtraParams.name]) {
              v[this.previewExtraParams.name] = v.originalName || v.name
            }
            if (!this.previewExtraParams.url && !v.filePath) {
              v.filePath = v.fileUrl
            } else if (this.previewExtraParams.url && !v[this.previewExtraParams.url]) {
              v[this.previewExtraParams.url] = v.filePath || v.fileUrl
            }
            return v
          }))
          return
        }

        this.downLoadRequest(file)
      },
      async downLoadRequest (file) {
        if (!this.token) {
          await this.getAccessoryToken()
        }
        const api = Api.downloadFile
        const params = {
          system: accessorySystemType,
          fileUrl: file.fileUrl || file.filePath
        }
        download(api.type, api.url, params)
      },
      async getAccessoryToken () {
        let token = await Store.syAccessory('accessoryToken').getter()
        if (token) {
          this.token = token
        } else {
          let res = await Store.syAccessory('getToken').getter()
          if (res.isOk) {
            this.token = res.content
            Store.syAccessory('accessoryToken').update(token)
          } else {
            this.token = ''
          }
        }
      },
      // 点击展开全部
      handleShowMore () {
        this.showMoreFlag = true
        this.showMore()
      },
      // 展开数据判断
      showMore () {
        if (this.showMoreFlag) {
          this.fileList = this.allFileList
        } else {
          this.fileList = this.allFileList.slice(0, 3)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.sy-accessory-file-detail {
  // max-width: 500px;
  width: 100%;
  display: inline-block;
  vertical-align: top;
  .file-item {
    cursor: pointer;
    font-size: 14px;
    // height: 24px;
    line-height: 24px;
    overflow: hidden;
    color: #303030;
    width: 100%;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 48px;
    .accessory-file-detail_item-status {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background: url($img-url + '163663639174472357.png') no-repeat;
      background-size: 50px;
    }
    word-break: break-all;
    .el-icon-download {
      display: none;
    }
    &:hover {
      background: #F9F9F9;
      border-radius: 14px;
      .el-icon-download {
        display: inline-block;
      }
      .accessory-file-detail_item-status {
        display: none;
      }
    }
  }
  .sy-accessory-file-detail-load-mare {
    font-size: 12px;
    line-height: 16px;
  }
}
.sy-accessory-file-detail-mini {
  .file-item {
    font-size: 12px;
  }
}
</style>
